import { useContext } from 'react';
import { PortalIDContext, PortalManagerContext } from '../context';
import { HasPortalParentContext } from '../context/HasPortalParentContext';
export var usePortalManagerWithID = function () {
    var manager = useContext(PortalManagerContext);
    var id = useContext(PortalIDContext);
    var hasPortalParent = useContext(HasPortalParentContext);
    if (hasPortalParent || !manager || id === undefined)
        return undefined;
    return { manager: manager, id: id };
};
